import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import CarouselSection from '@/pages/home/components/CarouselSection';
import ContactSection from '@/pages/home/components/ContactSection';
import AboutSection from '@/pages/home/components/AboutSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import CardsSection from '@/pages/home/components/CardsSection';
import IndexSection from '@/pages/home/components/IndexSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import FaqSection from '@/pages/home/components/FaqSection';
import MediaSection from '@/pages/home/components/MediaSection';
import AppSection from '@/pages/home/components/AppSection';
import RankingSection from '@/pages/home/components/RankingSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <ContactSection />
        <AboutSection />
        <CommentsSection />
        <CardsSection />
        <IndexSection />
        <UpdatesSection />
        <FeaturesSection />
        <TopicsSection />
        <FaqSection />
        <MediaSection />
        <AppSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}